import {useParams} from 'react-router-dom'
import Loading from '../../../../Common/Loading'
import {PammOffersTree} from '../../../../PammOffersTree'
import {Container} from './components/Container'
import {InvestSelfBanner} from './components/InvestSelfBanner'
import {usePammManagerOffers} from './usePammManagerOffers'

const DEFAULT_OFFER_NAME = 'Default'

/**
 * Money Manager view of their PAMM offers (reached via a PAMM account tile -> "View Offers").
 *
 * Renders the manager's offer together with every nested agent / sub-agent offer as a
 * hierarchical, expandable tree (PT-5399).
 */
export const PammManagerOffers = () => {
  const {accountId} = useParams<{accountId: string}>()
  const managerAccountId = Number(accountId)
  const {error, loading, offers} = usePammManagerOffers(managerAccountId)

  if (error) return null
  if (loading) return <Loading />

  // The auto-created "Default" offer is internal and never surfaced to managers.
  const visibleOffers = offers.filter((offer) => offer.name !== DEFAULT_OFFER_NAME)

  return (
    <Container>
      <InvestSelfBanner pammManagerAccountId={accountId} />
      <PammOffersTree offers={visibleOffers} />
    </Container>
  )
}
